import { attribute, hashKey } from '@awslabs-community-fork/dynamodb-data-mapper-annotations';
import { dynamicTableName } from '@pristine-ts/aws';
import { CalculationRunOptions } from '../options/calculations/calculation-run.options';
import { type } from '@pristine-ts/data-mapping-common';
import { CalculationKeynameEnum } from '../enums/calculations/calculation-keyname.enum';
import { SalaryDividendOptions } from '../options/calculations/salary-dividend/salary-dividend.options';
import { RolloverOptions } from '../options/calculations/rollover/rollover.options';
import { Section84_1Options } from '../options/calculations/section-84_1/section-84_1.options';
import { SalaryContributionsOptions } from '../options/calculations/salary-contributions/salary-contributions.options';
import { property } from '@pristine-ts/metadata';
import { RrspOptions } from '../options/calculations/rrsp/rrsp.options';

@dynamicTableName('CALCULATION_OPTIONS_TABLE_NAME')
export class CalculationOptionsModel {
  @hashKey()
  @property()
  calculationId: string;
  @type((target, propertyKey) => {
    const element: CalculationRunOptions = target[propertyKey];

    switch (element.calculationKeyname) {
      case CalculationKeynameEnum.SalaryDividendSimulation:
        return new SalaryDividendOptions();
      case CalculationKeynameEnum.RrspSimulation:
        return new RrspOptions();
      case CalculationKeynameEnum.Rollover:
        return new RolloverOptions();
      case CalculationKeynameEnum.Section84_1:
        return new Section84_1Options();
      case CalculationKeynameEnum.SalaryContributions:
        return new SalaryContributionsOptions();
    }

    return {};
  })
  @attribute({ unwrapNumbers: true })
  options: CalculationRunOptions;
  @attribute()
  @property()
  createdAt: Date;
  @attribute()
  @property()
  updatedAt: Date;
}
